/**
 * @generated SignedSource<<554478429ffafc2ce1e32fe5e73944a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording$data = {
  readonly __typename: string;
  readonly allRelevantParticipants?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_SpeakerRelabelForm_attendees">;
  }>;
  readonly attendees?: ReadonlyArray<{
    readonly email: string;
    readonly fullName: string | null;
    readonly image: string | null;
    readonly isTopUser: boolean;
  }>;
  readonly baseRecording?: {
    readonly allRelevantParticipants?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_SpeakerRelabelForm_attendees">;
    }>;
    readonly attendees?: ReadonlyArray<{
      readonly email: string;
      readonly fullName: string | null;
      readonly image: string | null;
      readonly isTopUser: boolean;
    }>;
  } | null;
  readonly id: string;
  readonly meetingRecordedVideoUrl: string | null;
  readonly transcript: any | null;
  readonly " $fragmentType": "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording";
};
export type TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording$key = {
  readonly " $data"?: TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "condition": "public",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecordingParticipant",
        "kind": "LinkedField",
        "name": "allRelevantParticipants",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TranscriptPanel_SpeakerRelabelForm_attendees"
          }
        ],
        "storageKey": null
      }
    ]
  },
  {
    "condition": "public",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecordingAttendee",
        "kind": "LinkedField",
        "name": "attendees",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTopUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "MeetingRecording",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecording",
          "kind": "LinkedField",
          "name": "baseRecording",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "MeetingRecordingClip",
      "abstractKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};
})();

(node as any).hash = "ee3277179cfb877593e5cdc5769de276";

export default node;
